module.exports = __webpack_public_path__ + "assets/media/s31.ec389cb7.mp3";